import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import zoomSdk from '@zoom/appssdk';

interface ILoginCard {
  headlineText: string;
  bodyText: string;
  handleClick?: React.MouseEventHandler<HTMLDivElement>;
  termsLink: string;
}
const LoginCard = ({
  headlineText,
  bodyText,
  handleClick,
  termsLink,
}: ILoginCard) => {
  const style: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    gap: '10px',
    background: 'rgba(4, 8, 9, 0.02)',
    border: '1px solid rgba(4, 8, 9, 0.08)',
    borderRadius: '8px',
    width: '202px',
    height: '180px',
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(81, 219, 205, 0.13)',
    },
  };

  const handleOpenUrl = () => {
    zoomSdk.openUrl({
      url: termsLink,
    });
  };

  return (
    <Box>
      <Box sx={style} onClick={handleClick}>
        <Typography
          fontWeight='600'
          lineHeight='24px'
          style={{ width: '186px' }}
        >
          {headlineText}
        </Typography>
        <Typography style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
          {bodyText}
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'relative',
          bottom: '40px',
          left: '16px',
        }}
      >
        <Typography variant='caption' fontSize='12px'>
          <a
            rel='noreferrer'
            target='_blank'
            href={termsLink}
            onClick={handleOpenUrl}
            style={{
              color: 'rgba(0, 0, 0, 0.84)',
              textDecorationColor: 'rgba(0, 0, 0, 0.84)',
            }}
          >
            Terms and conditions
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginCard;
